// Sürücü İzinleri — paylaşılan tarih/gün yardımcıları.
// Backend driver-availability.service.js ile tutarlı: haftanın günü 1=Pazartesi ... 7=Pazar.

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;

export const todayYMD = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

export const addDays = (ymd, delta) => {
  if (!ymd || !DATE_RE.test(ymd)) return ymd;
  const [y, mo, d] = ymd.split("-").map((n) => parseInt(n, 10));
  const dt = new Date(Date.UTC(y, mo - 1, d));
  dt.setUTCDate(dt.getUTCDate() + delta);
  const pad = (n) => String(n).padStart(2, "0");
  return `${dt.getUTCFullYear()}-${pad(dt.getUTCMonth() + 1)}-${pad(dt.getUTCDate())}`;
};

/** "YYYY-MM-DD" → ISO haftanın günü (1=Pazartesi ... 7=Pazar). */
export const isoWeekday = (ymd) => {
  if (!ymd || !DATE_RE.test(ymd)) return null;
  const [y, mo, d] = ymd.split("-").map((n) => parseInt(n, 10));
  const jsDay = new Date(Date.UTC(y, mo - 1, d)).getUTCDay(); // 0=Pazar ... 6=Cumartesi
  return ((jsDay + 6) % 7) + 1;
};

/** "YYYY-MM-DD" → "DD.MM.YYYY". */
export const longDate = (ymd) => {
  if (!ymd || !DATE_RE.test(ymd)) return ymd || "";
  const [y, mo, d] = ymd.split("-");
  return `${d}.${mo}.${y}`;
};

/** "YYYY-MM-DD" → "DD.MM". */
export const shortDate = (ymd) => {
  if (!ymd || !DATE_RE.test(ymd)) return ymd || "";
  const [, mo, d] = ymd.split("-");
  return `${d}.${mo}`;
};

/** Haftanın gün numaraları (1..7) — Pazartesi başlangıçlı sıra. */
export const WEEKDAY_ORDER = [1, 2, 3, 4, 5, 6, 7];

/** Kapsayıcı tarih aralığındaki tüm günleri "YYYY-MM-DD" dizisi olarak döner. */
export const expandDateRange = (start, end) => {
  if (!start || !end || !DATE_RE.test(start) || !DATE_RE.test(end)) return [];
  let a = start;
  let b = end;
  if (a > b) [a, b] = [b, a];
  const out = [];
  let cursor = a;
  let guard = 0;
  while (cursor <= b && guard < 1000) {
    out.push(cursor);
    cursor = addDays(cursor, 1);
    guard += 1;
  }
  return out;
};

/** İki string dizinin birleşimi (tekilleştirilmiş + sıralı). */
export const mergeSortedUnique = (a = [], b = []) => {
  const set = new Set([...(a || []), ...(b || [])]);
  return [...set].sort();
};
